import React, { Component } from 'react';
export default function (initialState, reducers, middlewares = []) {
    let dispatcher = (action) => {
        actionStack.push(action);
    };
    const actionStack = [];
    const reducer = (state, action, dispatch) => (reducers.reduce((newState, r) => r(newState, action, dispatch), state));
    const dispatch = (action) => dispatcher(action);
    const Context = React.createContext(Object.assign(Object.assign({}, initialState), { dispatch: (action) => {
            console.warn('Please add a Provider to your application first');
        } }));
    const Consumer = Context.Consumer;
    const useSelector = function (select) {
        const context = React.useContext(Context);
        return select(context);
    };
    const withState = function (select) {
        return (Comp) => (props) => (React.createElement(Consumer, null, (state) => (React.createElement(Comp, Object.assign({}, props, (select ? select(state, props) : {}))))));
    };
    const runMiddlewares = (name, state, action, dispatcher) => {
        middlewares.forEach((middleware) => {
            const run = middleware[name];
            run && run(state, action, dispatcher);
        });
        return state;
    };
    const Provider = class extends Component {
        constructor() {
            super(...arguments);
            this.state = Object.assign({}, initialState);
        }
        componentDidMount() {
            dispatcher = (action) => this.setState((state) => {
                runMiddlewares('before', state, action, dispatch);
                const newState = reducer(state, action, dispatch);
                runMiddlewares('after', newState, action, dispatch);
                return newState;
            });
            actionStack.forEach(dispatch);
            this.setState(Object.assign(Object.assign({}, initialState), { dispatcher }));
        }
        render() {
            return (React.createElement(Context.Provider, { value: this.state }, this.props.children));
        }
    };
    return { Provider, withState, useSelector, dispatch };
}
